import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Calendar, Clock } from 'lucide-react';

const BlogSection = () => {
  const blogs = [
    {
      title: 'The 7 types of Dubai free zone visas: 2025 guide',
      excerpt: 'Understanding the key differences between Dubai free zone visa types to make the best choice for your business setup in 2025.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80',
      date: 'Jan 15, 2025',
      readTime: '5 min read',
      link: '#blog-1',
    },
    {
      title: 'UAE Corporate Tax: Complete Guide 2025',
      excerpt: 'Step-by-step guide to UAE corporate tax registration, compliance requirements, and common mistakes to avoid.',
      image: 'https://images.unsplash.com/photo-1664382951020-41874ae61a44?w=600&q=80',
      date: 'Jan 12, 2025',
      readTime: '7 min read',
      link: '#blog-2',
    },
    {
      title: 'Mainland vs Free Zone: Which is right for you?',
      excerpt: 'Discover the pros and cons of UAE Mainland and Free Zone setups to choose the best option for your business.',
      image: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=600&q=80',
      date: 'Jan 8, 2025',
      readTime: '6 min read',
      link: '#blog-3',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            From The Blog
          </h2>
          <p className="text-xl text-gray-600 mb-6">
            <span className="font-semibold">Exploring trends and insights</span>
          </p>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Discover the latest insights and updates on the UAE's vibrant business community. From in-depth articles to setup guides, Firmzy offers valuable information and expertise to keep you informed about the dynamic UAE business landscape.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {blogs.map((blog, idx) => (
            <article
              key={idx}
              className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div 
                className="h-56 bg-cover bg-center relative overflow-hidden"
                style={{ backgroundImage: `url(${blog.image})` }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center gap-1">
                    <Calendar size={16} />
                    {blog.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock size={16} />
                    {blog.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-[#6B1B4D] transition-colors">
                  {blog.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {blog.excerpt}
                </p>
                <a 
                  href={blog.link}
                  className="inline-flex items-center text-[#DC143C] font-medium hover:underline group"
                >
                  Read More 
                  <ArrowRight className="ml-1 group-hover:translate-x-1 transition-transform" size={16} />
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center">
          <Button 
            className="bg-gradient-to-r from-[#6B1B4D] to-[#DC143C] text-white hover:shadow-lg transition-all px-8"
            size="lg"
          >
            View All Articles
            <ArrowRight className="ml-2" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;